import CameraIcon from '@tradera/blueprint/theme/icons2/camera.svg?jsx';
import { classNames } from 'tradera/utils/class-names';

export const EmptyImage = ({ className }: { className?: string }) => (
    <div
        className={classNames(
            'bg-secondary w-100 h-100 d-flex justify-content-center align-items-center',
            className,
        )}>
        <CameraIcon className="icon icon-dark icon-lg" />
    </div>
);
